export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-filled-ea1a9c59cb312d57f667ce6a4ff456a9.svg";